var exports = {
  "x6": "xa15a2ab7--d53345--button",
  "r9": "xa15a2ab7--d53345--disabled",
};

module.exports = exports;
